import { Box, Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import Regimens from '../../../components/Regimens'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useDietFormState } from './hooks/useDietFormState'
import { QuestionSection } from './components/QuestionSection'
import WaterQuestions from './components/WaterQuestions'
import MacroQuestions from './components/MacroQuestions'
import CarbDietQuestions from './components/CarbDietQuestions'
import DairyQuestions from './components/DairyQuestions'
import GrainQuestions from './components/GrainQuestions'

export const DietsPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, lists } = useDietFormState()
  const purpleBubbleContent = usePurpleBubblesText('Step-7')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <Stack spacing={4}>
      <form onSubmit={handleSubmit}>
        <Box mb={4}>
          <MonthlyReportHeader title='Diet' />
        </Box>
        {purpleBubbleContent?.text && (
          <PurpleBubbleContent text={purpleBubbleContent.text} />
        )}
        <QuestionSection Component={WaterQuestions} />
        <QuestionSection Component={MacroQuestions} />
        <QuestionSection Component={CarbDietQuestions} />
        <QuestionSection Component={DairyQuestions} />
        <QuestionSection Component={GrainQuestions} />
      </form>

      <Regimens recordLabel='Diet' lists={lists} allowUpdate={false} />
      <form onSubmit={handleSubmit}>
        <MonthlyReportNavButtons />
      </form>
    </Stack>
  )
}
